// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCS2tAD7A_qXvRQA6jpkk5AJvDvXUCdoKY",
//   authDomain: "restoku-backoffice.firebaseapp.com",
//   projectId: "restoku-backoffice",
//   storageBucket: "restoku-backoffice.appspot.com",
//   messagingSenderId: "673765200949",
//   appId: "1:673765200949:web:13bc8b5998eef834d30d7c",
//   measurementId: "G-Y70M3WBSVF"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// console.log = function() {}

Vue.config.productionTip = false

Vue.prototype.$user = store.state.settings.user
Vue.prototype.$toko = store.state.settings.toko

Vue.prototype.$objectToQuery = (params) => {
  return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

store.commit('settings/closeToast')
Vue.prototype.$toast = (text) => {
  store.commit('settings/setToast', { open: true, text: text })
  setTimeout(() => {
    store.commit('settings/closeToast')
  }, 3000)
}

Vue.filter('number', function (value) {
  if (value || value == 0)
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  else
    return ''
})

Vue.filter('decimal', function (value) {
  const rounded = Math.round(value * 1000) / 1000
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js